export const floatingProgressMeter = () => {
  const isEmbbeded = document.querySelector("[data-wm-is-embbeded]");

  if (isEmbbeded) {
    return;
  }

  const form = document.querySelector("[data-wm-form='petition']");

  if (!form) {
    return;
  }

  const options = {
    rot: document.body,
    threshold: [0, 0.25, 0.5, 0.75, 1],
  };

  const callback = (entry) => {
    form.classList.toggle("is-floating", !entry[0].isIntersecting);
  };

  const observer = new IntersectionObserver(callback, options);
  observer.observe(form);
};
